import React from 'react'
import NewCount from '../../molecules/BaseConversation/NewCount'
import SelectedRectangle from '../SelectedItemRectangle'
import useStyles from './styles'

interface HamburgerMenuListItemProps {
  selected?: boolean
  icon: React.ReactNode | JSX.Element | (() => JSX.Element)
  text: string
  onClick: () => void
  testid: string
  notifications?: number
  props?: React.ComponentPropsWithoutRef<'li'>
  children?: JSX.Element | JSX.Element[]
}

const HamburgerMenuListItem: React.FC<HamburgerMenuListItemProps> = ({
  selected,
  icon,
  text,
  onClick,
  testid,
  notifications,
  ...props
}) => {
  const classes = useStyles({ selected })
  return (
    <li
      className={classes.root}
      onClick={() => onClick()}
      data-testid={testid}
      {...props}
    >
      <>
        {selected && (
          <SelectedRectangle
            style={{ marginRight: '1rem', background: '#B64FCD' }}
          />
        )}
        {icon}

        {notifications > 0 && (
          <NewCount count={notifications} className={classes.dot} />
        )}
        <label className={classes.label}>{text}</label>
      </>
    </li>
  )
}
export default HamburgerMenuListItem
